import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

const AuditTrailSummaryComponent = () => {
  const { getRouteKey } = useRouter();
  const routeIdConfig = getRouteKey("INVENTORY", "id");
  const { routeState } = useRouteInfo(routeIdConfig);

  const { auditTrailTableSummaryData } = routeState.state as IInventoryState;
  const perClinicData = auditTrailTableSummaryData?.summary?.per_clinic || [];
  const overallData = auditTrailTableSummaryData?.summary?.overall;

  return (
    <div className="rounded-xl bg-[#F5F5F5] mt-5 p-2 w-full">
      <div className="text-sm font-semibold mt-2">Summary</div>
      <div className="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {perClinicData?.map((sum, id) => (
          <div
            key={id}
            className="rounded-xl bg-white p-4 flex flex-col justify-between hover:shadow-md transition-all duration-200"
          >
            <div className="bg-gray-100 p-2 rounded-lg">
              <p className="text-xs font-semibold text-gray-800 break-words">
                {sum?.clinic_name}
              </p>
            </div>

            <p className="text-xs font-medium mt-3">
              Opening Qty: {sum?.opening_qty}
            </p>

            <div className="mt-3 grid grid-cols-2 gap-8 text-xs">
              <div className="flex items-center gap-1 text-green-700 font-semibold">
                <span>Inwards Total:</span>
                <span>{sum?.inwards_total_qty}</span>
                <FaArrowUp size={10} />
              </div>

              <div className="flex items-center gap-1 text-red-500 font-semibold">
                <span>Outwards Total:</span>
                <span>{sum?.outwards_total_qty}</span>
                <FaArrowDown size={10} />
              </div>
            </div>

<div className="mt-3 grid grid-cols-2 gap-x-10 text-xs">
                <div className="space-y-1">
                {sum?.inwards_total?.map((inwards, id) => (
                  <div key={id} className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
                    <span className="text-gray-500 break-words">
                      {inwards?.action_type}
                    </span>
                    <span className="font-medium whitespace-nowrap text-right">
                      {inwards?.action_quantity}
                    </span>
                  </div>
                ))}
              </div>

              <div className="space-y-1">
                {sum?.outwards_total?.map((outwards, id) => (
                  <div key={id} className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
                    <span className="text-gray-500 break-words">
                      {outwards?.action_type}
                    </span>
                    <span className="font-medium whitespace-nowrap text-right">
                      {outwards?.action_quantity}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <p className="text-xs font-medium mt-3 border-t pt-2">
              Closing Qty: {sum?.closing_qty}
            </p>
          </div>
        ))}

        {overallData && Object.keys(overallData).length !== 0 && (
          <div className="rounded-xl bg-white p-4 flex flex-col justify-between hover:shadow-md transition-all duration-200 border border-gray-200">

            <div className="bg-zinc-100 p-2 rounded-lg">
              <p className="font-semibold text-xs break-words">
                {overallData?.clinic_name}
              </p>
            </div>

            <p className="text-xs font-medium mt-3">
              Opening Qty: {overallData?.opening_qty}
            </p>

            <div className="mt-3 grid grid-cols-2 gap-8 text-xs">
              <div className="flex items-center gap-1 text-green-700 font-semibold">
                <span>Inwards Total:</span>
                <span>{overallData?.inwards_total_qty}</span>
                <FaArrowUp size={10} />
              </div>

              <div className="flex items-center gap-1 text-red-500 font-semibold">
                <span>Outwards Total:</span>
                <span>{overallData?.outwards_total_qty}</span>
                <FaArrowDown size={10} />
              </div>
            </div>

<div className="mt-3 grid grid-cols-2 gap-x-10 text-xs">
                <div className="space-y-1">
                {overallData?.inwards_total?.map((inwards, id) => (
                  <div key={id} className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
                    <span className="text-gray-500 break-words">
                      {inwards?.action_type}
                    </span>
                    <span className="font-medium whitespace-nowrap text-right">
                      {inwards?.action_quantity}
                    </span>
                  </div>
                ))}
              </div>

              <div className="space-y-1">
                {overallData?.outwards_total?.map((outwards, id) => (
                  <div key={id} className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2">
                    <span className="text-gray-500 break-words">
                      {outwards?.action_type}
                    </span>
                    <span className="font-medium whitespace-nowrap text-right">
                      {outwards?.action_quantity}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <p className="text-xs font-medium mt-3 border-t pt-2">
              Closing Qty: {overallData?.closing_qty}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditTrailSummaryComponent;
